import { AUTH_TRANSACTION_KEY, WORKSUITE_IDENTITY_CLIENT } from "./authConstants";
import { readIntendedRoute, saveIntendedRoute } from "./intendedRoute";

function getRegisteredReturnUrl() {
  const configured = process.env.REACT_APP_CAMPAIGNS_RETURN_URL;
  if (configured) return new URL(configured).toString();
  return new URL("/", window.location.origin).toString();
}

export function buildCampaignsAccountsUrl(pathname = "/login", params = {}) {
  const intendedPath = params.intendedPath || readIntendedRoute();
  saveIntendedRoute(intendedPath);
  const url = new URL(pathname, WORKSUITE_IDENTITY_CLIENT.accountsUrl);
  url.searchParams.set("client_id", WORKSUITE_IDENTITY_CLIENT.clientId);
  url.searchParams.set("referralApp", WORKSUITE_IDENTITY_CLIENT.displayName);
  url.searchParams.set("identity_protocol_version", WORKSUITE_IDENTITY_CLIENT.protocolVersion);
  url.searchParams.set("redirect_uri", params.redirect_uri || getRegisteredReturnUrl());
  Object.entries(params).forEach(([key, value]) => {
    if (!["redirect_uri", "intendedPath"].includes(key) && value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, String(value));
    }
  });
  return url.toString();
}

export function beginCampaignsIdentity(mode = "login", options = {}) {
  window.sessionStorage.removeItem(AUTH_TRANSACTION_KEY);
  const pathname = mode === "signup" ? "/register" : "/login";
  window.location.assign(buildCampaignsAccountsUrl(pathname, options));
}
